export default __webpack_public_path__ + "static/media/shield.687935fc.svg";